<template>
  <div class="my-20">
    <h2 class="my-10 text-header2 md:text-desktop-header2">
      {{ slice.primary.section_title }}
    </h2>

    <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <div
        v-for="(pack, index) in slice.primary.packs"
        :key="index"
        class="p-6"

        :class="[
          useTheme(slice.primary.theme || ''),
          /* Make the last block bigger if total is odd */
          slice.primary.packs.length % 2 !== 0 && index + 1 === slice.primary.packs.length
            ? 'lg:col-span-2'
            : '',
        ]"
      >
        <div class="justify-between text-center lg:flex lg:text-left">
          <h2 class="text-header3 md:text-desktop-header3">
            {{ pack.title }}
          </h2>
          <h3 class="text-large-copy md:text-desktop-large-copy">
            {{
              pack.price != 0 && pack.price != null && pack.second_price != 0 && pack.second_price != null
                ? `${useCurrencyFormat(pack.price || 0)} - ${useCurrencyFormat(pack.second_price || 0)}`
                : pack.price != 0 && pack.price != null
                  ? useCurrencyFormat(pack.price || 0)
                  : ''
            }}
          </h3>
        </div>

        <PrismicRichText
          :field="pack.description"
          class="mt-10 text-body-copy"
        />

        <a
          v-if="prismic.asLink(pack.link)"
          :href="prismic.asLink(pack.link) ?? ''"
          class="mt-10 block rounded-md border border-charcoal-100 bg-charcoal-100 px-5 py-2 text-center text-large-copy text-white transition-colors hover:border-charcoal-75 hover:bg-charcoal-75"
        >
          {{ pack.button_label ? pack.button_label : 'Find out more' }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Content } from "@prismicio/client";

const prismic = usePrismic();
const { useCurrencyFormat } = useFilters();

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
const props = defineProps(
  getSliceComponentProps<Content.MembershipsSlice>([
    "slice",
    "index",
    "slices",
    "context",
  ]),
);
</script>
